<template>
  <div id="page-vue">
    <!-- Speed test part -->
    <div id="section3">

      <!-- Mobile -->
      <div class="mobile">
        <div class="row">
          <div class="small-12 columns">
            <h2 class="white-text">Your current internet speed</h2>
            <div class="buttons">
              <button @click="SetMySpeed('15',$event)" :class="{ active: speedTestFilter.yourSpeed == '15' }">15 Mbps</button>
              <button @click="SetMySpeed('60',$event)" :class="{ active: speedTestFilter.yourSpeed == '60' }">60 Mbps</button>
              <button @click="SetMySpeed('150',$event)" :class="{ active: speedTestFilter.yourSpeed == '150' }">150 Mbps</button>
              <button @click="SetMySpeed('250',$event)" :class="{ active: speedTestFilter.yourSpeed == '250' }">250 Mbps</button>
              <!--<button @click="SetMySpeed('100',$event)" :class="{ active: speedTestFilter.yourSpeed == '100' }">100 Mbps</button>-->
            </div>
            <div class="hoSelect">
              <select v-model="speedTestFilter.benchmarkSpeed" v-on:change="SpeedTest_Click">
                <option value="-1">Online Activity</option>
                <option value="2">Upload 100 photos to Facebook (300MB)</option>
                <option value="0">Download HD movie (5GB)</option>
                <option value="1">Download an Xbox game (25GB)</option>
                <!-- <option value="3">Upload 500 High-Res photos (2.5GB )</option> -->
              </select>
            </div>
            <div class="graph">
              <canvas id="canvasSpeedTestMobile" width="800" height="800" style="width:100%"></canvas>
              <div class="inner-circle"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop -->
      <div class="desktop">
        <div class="row">
        <div class="medium-5 small-12 columns">
          <h2 class="white-text">How does it compare?</h2>
          <h3>Curious to know how fast the Tech Amenity Internet really is? Take the speed comparison test today.</h3>
          <select v-model="speedTestFilter.yourSpeed">
            <option value="-1">Your current internet speed</option>
            <option value="15">15 Mbps</option>
            <option value="60">60 Mbps</option>
            <option value="150">150 Mbps</option>
            <option value="250">250 Mbps</option>
            <!--<option value="100">100 Mbps</option>-->
          </select>
          <select v-model="speedTestFilter.benchmarkSpeed">
            <option value="-1">Online Activity</option>
            <option value="2">Upload 100 photos to Facebook (300MB)</option>
            <option value="0">Download HD movie (5GB)</option>
            <option value="1">Download an Xbox game (25GB)</option>
            <!-- <option value="3">Upload 500 High-Res photos (2.5GB )</option> -->
          </select>
          <button class="button" @click="SpeedTest_Click">Take the Test</button>
        </div>

        <div class="medium-7 small-12 columns">
          <div class="graph">
            <canvas id="canvasSpeedTest" width="855" height="530"></canvas>
            <div class="inner-circle"></div>
          </div>
        </div>

      </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { CanvasSpeedtest } from '../assets/scripts/canvasSpeedTest'
  import { CanvasSpeedtestMobile } from '../assets/scripts/canvasSpeedTestMobile'

  export default {
    name: 'Speed-Test',

    data () {
      return {
        isNowMobile: false,
        canvasSpeedTest: null,
        canvasSpeedTestMobile: null,
        interval: 10000,
        n: 0,
        speedTestFilter: {
          yourSpeed: 15,
          benchmarkSpeed: -1
        },
        activeButton: null
      }
    },

    mounted: function () {
      var self = this

      this.$nextTick(function () {
        window.addEventListener('resize', this.CheckForMobile)
      })
      this.CheckForMobile()
      
      setTimeout(() => {
        this.canvasSpeedTest = new CanvasSpeedtest('canvasSpeedTest', {
          yourSpeed: '15 Mbps'
        })
        this.canvasSpeedTestMobile = new CanvasSpeedtestMobile('canvasSpeedTestMobile', {
          isMobile: true,
          yourSpeed: '15 Mbps'
        })
      }, 750)

      
    },

    methods: {
      CheckForMobile: function (event) {
        this.isNowMobile = document.documentElement.clientWidth < 768
      },

      SetMySpeed: function (speed, e) {
        this.speedTestFilter.yourSpeed = speed
        this.SpeedTest_Click()
      },

      SpeedTest_Click: function () {
        var /*increment30mb,*/ increment300mb, /*increment1gb,*/ incrementYourSpeed, yourSpeed
        var self = this

        if (this.speedTestFilter.benchmarkSpeed == '-1') {
          return
        }

        var trackingBenchmarkSpeed = ''
        switch (this.speedTestFilter.benchmarkSpeed) {
          default:
          case '0':
            trackingBenchmarkSpeed = 'Download HD movie (5GB)'

            //increment30mb = 0.0005
            increment300mb = 0.005
            //increment1gb = 0.018

            switch (this.speedTestFilter.yourSpeed) {
              default:
              case '15':
                incrementYourSpeed = 0.00025
                yourSpeed = '15 Mbps'
                break
              case '60':
                incrementYourSpeed = 0.001
                yourSpeed = '60 Mbps'
                break
              case '150':
                incrementYourSpeed = 0.0025
                yourSpeed = '150 Mbps'
                break
              case '250':
                incrementYourSpeed = 0.00415
                yourSpeed = '250 Mbps'
                break
              // case '100':
              //   incrementYourSpeed = 0.0017
              //   yourSpeed = '100 Mbps'
              //   break
            }
            break
          case '1':                   // Download 25Gb
            trackingBenchmarkSpeed = 'Download an Xbox game (25GB)'

            //increment30mb = 0.0001
            increment300mb = 0.001
            //increment1gb = 0.0036

            switch (this.speedTestFilter.yourSpeed) {
              default:
              case '15':
                incrementYourSpeed = 0.00005
                yourSpeed = '15 Mbps'
                break
              case '60':
                incrementYourSpeed = 0.0002
                yourSpeed = '60 Mbps'
                break
              case '150':
                incrementYourSpeed = 0.0005
                yourSpeed = '150 Mbps'
                break
              case '250':
                incrementYourSpeed = 0.00083
                yourSpeed = '250 Mbps'
                break
              // case '100':
              //   incrementYourSpeed = 0.00034
              //   yourSpeed = '100 Mbps'
              //   break
            }
            break
          case '2':                   // Upload 100Mb
            trackingBenchmarkSpeed = 'Upload 100 photos to Facebook (300MB)'

            //increment30mb = 0.008
            increment300mb = 0.2
            //increment1gb = 0.7

            switch (this.speedTestFilter.yourSpeed) {
              default:
              case '15':
                incrementYourSpeed = 0.01
                yourSpeed = '15 Mbps'
                break
              case '60':
                incrementYourSpeed = 0.04
                yourSpeed = '60 Mbps'
                break
              case '150':
                incrementYourSpeed = 0.1
                yourSpeed = '150 Mbps'
                break
              case '250':
                incrementYourSpeed = 0.166
                yourSpeed = '250 Mbps'
                break
              // case '100':
              //   incrementYourSpeed = 0.065
              //   yourSpeed = '100 Mbps'
              //   break
            }
            break
          // case '3':                   // Upload 2.5Gb
          //   trackingBenchmarkSpeed = 'Upload 2.5Gb'
          //
          //   //increment30mb = 0.001
          //   increment300mb = 0.005
          //   increment1gb = 0.036
          //
          //   switch (this.speedTestFilter.yourSpeed) {
          //     default:
          //     case '10':
          //       incrementYourSpeed = 0.0004
          //       yourSpeed = '10 Mbps'
          //       break
          //     case '17':
          //       incrementYourSpeed = 0.0006
          //       yourSpeed = '17 Mbps'
          //       break
          //     case '38':
          //       incrementYourSpeed = 0.0012
          //       yourSpeed = '38 Mbps'
          //       break
          //     case '76':
          //       incrementYourSpeed = 0.0024
          //       yourSpeed = '76 Mbps'
          //       break
          //     case '100':
          //       incrementYourSpeed = 0.0034
          //       yourSpeed = '100 Mbps'
          //       break
          //   }
          //   break
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(
          {
            'event': 'ctaClick',
            'ctaName': 'Start',
            'yourSpeed': self.speedTestFilter.yourSpeed,
            'benckMark': trackingBenchmarkSpeed
          })

        this.canvasSpeedTest.SetOptions({
          //increment30mb: increment30mb,
          increment300mb: increment300mb,
          //increment1gb: increment1gb,
          incrementYourSpeed: incrementYourSpeed,
          yourSpeed: yourSpeed
        })
        this.canvasSpeedTestMobile.SetOptions({
          //increment30mb: increment30mb,
          increment300mb: increment300mb,
          //increment1gb: increment1gb,
          incrementYourSpeed: incrementYourSpeed,
          yourSpeed: yourSpeed
        })

        if (!this.isNowMobile) {
          this.canvasSpeedTest.Start()
        }
        else {
          this.canvasSpeedTestMobile.Start()
        }
      },

    }
  }
</script>